import { MutationKey } from '@tanstack/react-query';

const baseKey: MutationKey = ['xeroInvoice'];

export const xeroInvoiceMutationKeys = {
  baseKey,
  connect: [...baseKey, 'connect'],
  disconnect: [...baseKey, 'disconnect'],
};
